export const getQuery = () => {
	const { location } = window
	const params = location.search
		.substr(1)
		.split('&')
		.map((el) => el.split('='))
	return params.reduce((acc, [key, value]) => {
		if (key) acc[key] = value ? decodeURIComponent(value) : value
		return acc
	}, {} as Record<string, string>)
}
